import axios from "axios";
import logs from "../../models/monitores/logs";
import errors from "../../models/monitores/errors";
import quantities from "../../models/monitores/quantities";
import config from "../../models/monitores/config";
import status from "../../models/monitores/status";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getLogs() {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/ca3/info/logs`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return logs.fromJson(item);
        });
      });
  }

  getErrors() {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/ca3/info/errors`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return errors.fromJson(item);
        });
      });
  }

  getQuantities() {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/ca3/info/cantidades`, { headers })
      .then(({ data }) => {
        return quantities.fromJson(data);
      });
  }

  getConfig() {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/ca3/info/config`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return config.fromJson(item);
        });
      });
  }
  getStatus(periodo) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const date = periodo == undefined ? moment().format("YYYY-MM-DD") : periodo;
    return axios
      .get(`${url}/ca3/info/estados/${date}`, { headers })
      .then(({ data }) => {
        return status.fromJson(data);
      });
  }
  activate(act) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.patch(`${url}/ca3/activar/${act}`, { headers });
  }
  startDate(date) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.patch(`${url}/ca3/diainicio/${date}`, { headers });
  }
}
export default service;
